import { AddToWhitelist, CheckWhitelist, GetCurrentUserLazy } from "common/graphql/queryDescriptors";
import { useCustomQuery } from "common/store/hooks/useCustomQuery";

export const useAddToWhitelist = ({
  onSuccess,
}: any) => {
  const { 
    execute: executeAddToWhitelist,
    loading: addToWhitelistLoading,
    errorInfo: addToWhiteListErrorInfo,
  } = useCustomQuery(
    AddToWhitelist({
      onSuccess: () => {
        whitelistDone();
      },
    })
  );

  const {
    execute: whitelistDone,
    loading: checkWhitelistLoading,
    errorInfo: checkWhitelistErrorInfo
  } = useCustomQuery(
    CheckWhitelist({
      onSuccess: () => {
        executeGetCurrentUser();
      },
    })
  );

  const {
    execute: executeGetCurrentUser,
    loading: getCurrentUserLoading,
    errorInfo: getCurrentUserErrorInfo
  } = useCustomQuery(
    GetCurrentUserLazy({
      onSuccess: () => {
        onSuccess();
      },
    })
  );

  return {
    executeAddToWhitelist,
    loading: addToWhitelistLoading || checkWhitelistLoading || getCurrentUserLoading,
    errorInfo: 
      addToWhiteListErrorInfo ? addToWhiteListErrorInfo :
      checkWhitelistErrorInfo ? checkWhitelistErrorInfo :
      getCurrentUserErrorInfo,
  };
};
